import React from 'react'
import { SvgIcon } from '@mui/material'

export const UserAddIcon = (props) => {
    return (
        <SvgIcon {...props} color='white'  viewBox='0 0 33 33 '>
            <path d="M20 18L14 18M17 15V21M7.68213 14C8.63244 14.6318 9.77319 15 10.9999 15C11.7012 15 12.3744 14.8797 13 14.6586M10.5 21H5.6C5.03995 21 4.75992 21 4.54601 20.891C4.35785 20.7951 4.20487 20.6422 4.10899 20.454C4 20.2401 4 19.9601 4 19.4V17C4 15.3431 5.34315 14 7 14H7.5M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z" stroke="#8EA7C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
